export enum FollowUpPolicyEnum {
  NoFreeFollowUp = 1,
  FreeFollowUp = 2,
  CaseByCase = 3,
}
